<template>
    <div class="container-fluid">
        <h2>Escort Blog</h2>
        <div class="row">
            <div class="col-sm-3" v-for="blog of blogs" :key="blog.id">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">{{ blog.title }}</h5>
                        <p class="card-text">
                            <img :src="`data:image/jpg;base64,${blog.images[0].picture}`" :alt="blog.title" class="img-fluid">
                        </p>
                        <router-link :to="{name: 'BlogShow', params: { slug: blog.slug }}" class="btn btn-primary">Read</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BlogComponent",
        data() {
            return {
                blogs: []
            }
        },
        methods: {
            fetchData() {
                this.$http.get(`${process.env.VUE_APP_BLOG_API}/news?page=0&pagesize=3`)
                    .then(response => {
                        this.blogs = response.data.content;
                    })
            }
        },
        created() {
            this.fetchData()
        }
    }
</script>
